import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from '../shared-material.module';

// ONLY FOR DEMO
// ALWAYS REQUIRED
import { ConfirmComponent } from '../services/app-confirm/confirm.component';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { FormsModule } from '@angular/forms';
import { FormModule } from '../../form/form.module';
import { ListComponent } from './list/list.component';
import { ListTextComponent } from './list/list-text.component';
import { ButtonComponent } from './button/button.component';
import { MenuLayoutComponent } from './layouts/menu-layout/menu-layout.component';
import { SharedDirectivesModule } from '../directives/shared.directives.module';
import { SupportButtonComponent } from './support-button/support-button.component';
import { PageToolbarComponent } from './page-toolbar/page-toolbar.component';
import { MarTableComponent } from './table/mar-table.component';
import { AggridCollectionFilterComponent } from './ag-grid/aggrid-collection-filter/aggrid-collection-filter.component';
import { AggridDateFilterComponent } from './ag-grid/aggrid-date-filter/aggrid-date-filter.component';

const components = [
  AggridCollectionFilterComponent,
  SupportButtonComponent,
  PageToolbarComponent,
  ButtonComponent,
  ListComponent,
  ListTextComponent,
  AuthLayoutComponent,
  ConfirmComponent,
  MenuLayoutComponent
];

@NgModule({
  imports: [
    SharedDirectivesModule,
    CommonModule,
    FormModule,
    RouterModule,
    SharedMaterialModule,
    FormsModule,
  ],
  declarations: components,
  exports: components
})
export class SharedComponentsModule {
}
